import type { AnyRoute } from "@tanstack/react-router";

import { createGprsListRoutes } from "./createGprsListRoutes";
import type { GprsRouteDeps } from "./gprsRouteContext";

export type { GprsRouteDeps, GprsRouteFactory } from "./gprsRouteContext";

export function createGprsRoutes(deps: GprsRouteDeps): AnyRoute[] {
  return [...createGprsListRoutes(deps)];
}
